module.exports = __webpack_public_path__ + "static/media/logo-icon.66748460.svg";